﻿import {
  appendQueryParameters,
  fetchBaseQueryWrapper,
  NO_CACHING,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const historyApi = createApi({
  reducerPath: "historyApi",
  baseQuery: fetchBaseQueryWrapper({ path: "history" }),
  keepUnusedDataFor: NO_CACHING,
  endpoints: (build) => ({
    getProjectHistory: build.query({
      query: ({ projectId, queryParameters }) =>
        appendQueryParameters(`projects/${projectId}`, queryParameters),
      transformResponse: ({ data }) => data,
    }),
    getScheduleHistoryAsOfDate: build.query({
      query: ({ projectId, scheduleId, asOfDate }) =>
        appendQueryParameters(`projects/${projectId}/schedule/${scheduleId}`, {
          asOfDate,
        }),
      transformResponse: ({ data }) => data,
    }),
    getHistoryLogsById: build.query({
      query: ({ parentEntityId }) => `historyLog/${parentEntityId}`,
      transformResponse: ({ data }) => data,
    }),
    getProjectStatusHistory: build.query({
      query: ({ projectId, statusId }) =>
        `projectStatus/${projectId}/${statusId}`,
      transformResponse: ({ data }) => data,
    }),
    getVpinProjectHistory: build.query({
      query: ({ projectId, queryParameters }) =>
        appendQueryParameters(`projects/${projectId}/vpin`, queryParameters),
      transformResponse: ({ data }) => data,
    }),
  }),
});

export const {
  useGetProjectHistoryQuery,
  useGetScheduleHistoryAsOfDateQuery,
  useGetHistoryLogsByIdQuery,
  useGetProjectStatusHistoryQuery,
  useGetVpinProjectHistoryQuery,
} = historyApi;
